// extracted by mini-css-extract-plugin
export var equalColumn = "_hr-0";